import { Link } from 'react-router-dom';

export default function Footer() {
  const mainSiteUrl = 'https://kaspreadsheet.com';

  const footerLinks = [
    {
      title: 'Categories',
      links: [
        { label: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
        { label: 'Hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
        { label: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
        { label: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
      ],
    },
    {
      title: 'SEO Guides',
      links: [
        { label: 'Ultimate Guide', url: '/superbuy-spreadsheet-guide' },
        { label: 'Shoes Guide', url: '/superbuy-spreadsheet-shoes-guide' },
        { label: 'Hoodies Guide', url: '/superbuy-spreadsheet-hoodies-guide' },
        { label: 'Bags Guide', url: '/superbuy-spreadsheet-bags-guide' },
        { label: 'Accessories Guide', url: '/superbuy-spreadsheet-accessories-guide' },
      ],
    },
    {
      title: 'Quick Links',
      links: [
        { label: 'superbuy sheet', url: mainSiteUrl },
        { label: 'buy it now', url: mainSiteUrl },
        { label: 'kaspreadsheet.com', url: mainSiteUrl },
        { label: 'Home', url: '/' },
      ],
    },
    {
      title: 'Information',
      links: [
        { label: 'Privacy Policy', url: '#' },
        { label: 'Terms of Use', url: '#' },
        { label: 'Disclaimer', url: '#' },
        { label: 'Contact', url: mainSiteUrl },
      ],
    },
  ];

  const isExternal = (url: string) => url.startsWith('http');

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 pt-14 md:pt-20 pb-8 md:pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-lg md:text-xl font-semibold tracking-tight">
                superbuyspread<span className="text-accent-400">.</span>skin
              </span>
            </Link>
            <p className="mt-3 text-sm text-primary-200/70 leading-relaxed max-w-[220px]">
              The Global Fashion Spreadsheet — Updated Daily with the Best Finds.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-primary-600/40 text-primary-200 hover:bg-primary-800 hover:text-background-50 transition-all cursor-pointer"
                aria-label="Visit kaspreadsheet.com"
              >
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-primary-600/40 text-primary-200 hover:bg-primary-800 hover:text-background-50 transition-all cursor-pointer"
                aria-label="Superbuy Sheet"
              >
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-3 md:mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {isExternal(link.url) ? (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-primary-200/60 hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.url}
                        className="text-sm text-primary-200/60 hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-primary-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-300/50">
            &copy; {new Date().getFullYear()} superbuyspread.skin. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-primary-300/50 hover:text-primary-200 transition-colors cursor-pointer">Privacy</a>
            <a href="#" className="text-xs text-primary-300/50 hover:text-primary-200 transition-colors cursor-pointer">Terms</a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-primary-300/50 hover:text-primary-200 transition-colors cursor-pointer">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}